import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=1cbbc1cb&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=1cbbc1cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbbc1cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbbc1cb')) {
      api.createRecord('1cbbc1cb', component.options)
    } else {
      api.reload('1cbbc1cb', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=1cbbc1cb&scoped=true&", function () {
      api.rerender('1cbbc1cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Vouchers/EditPage.vue"
export default component.exports